import { injectable } from "inversify";
import { Either, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../domain/entities/ErrorEntity";
import DashboardRepository, { BasicDashboardData } from "../../../domain/repositories/DashboardRepository";

@injectable()
export default class DashboardRepositoryFake implements DashboardRepository {
    
    public getBasicData = async (): Promise<Either<ErrorEntity, BasicDashboardData>> => {
        // Simular datos fake para el dashboard
        const basicData: BasicDashboardData = {
            workedHours: [
                { label: "Enero", value: 160 },
                { label: "Febrero", value: 180 },
                { label: "Marzo", value: 170 },
                { label: "Abril", value: 190 },
                { label: "Mayo", value: 200 },
                { label: "Junio", value: 185 }
            ],
            assistedShifts: [
                { label: "Enero", value: 45 },
                { label: "Febrero", value: 52 },
                { label: "Marzo", value: 48 },
                { label: "Abril", value: 55 },
                { label: "Mayo", value: 60 },
                { label: "Junio", value: 58 }
            ],
            noAssistedShifts: [
                { label: "Enero", value: 5 },
                { label: "Febrero", value: 3 },
                { label: "Marzo", value: 7 },
                { label: "Abril", value: 4 },
                { label: "Mayo", value: 2 },
                { label: "Junio", value: 6 }
            ]
        };

        return right(basicData);
    }
}